import _ from 'lodash';

const LOCALE_PREFIX = 'components/Password/password';

// Validating the password for PayPal accepted format
const passwordHints = (intl, value) => {
    const hints = [
        {
            // Shorter than 8 characters
            case: 'shortlengthCheck',
            pattern: /^(?=.{8,}).*$/g
        },
        {
            // Does not contain a number or special character
            case: 'presenceOfSymbol',
            pattern: /[0-9!-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/\\]/g
        },
        {
            // Contains a common/forbidden word
            case: 'legal',
            content: 2,
            // From: https://github.paypal.com/ConsumerWeb-R/paypal-validators/blob/master/lib/password/simple.js
            // OAS validation: http://xotoolslvs01.qa.paypal.com/gitsource/xref/Core-R__code__master/github/package/config/validationconfig/cdbs/validationconfig.layout#19
            pattern: /^((?!(access14|americanidol|baseball|baseball1|bigdaddy|blink182|butthead|cocacola|computer|corvette|cowboys|danielle|dolphins|einstein|firebird|football|football1|iloveyou|iloveyou1|internet|jennifer|jordan23|liverpool|liverpool1|marlboro|maverick|melanie|michelle|midnight|mistress|mountain|myspace1|password|password1|princess1|qwertyui|redwings|rush2112|samantha|scorpion|slipknot1|srinivas|startrek|starwars|sunshine|superman|superman1|swimming|trustno1|victoria|whatever|passwort|passwort1|frankfurt|fussball)).)+$/gi
        }
    ];
    const msgs = [];
    let hintType;
    for (const hint of hints) {
        if (!hint.pattern.test(value)) {
            hintType = {
                msg: intl.formatMessage({
                    id: `${LOCALE_PREFIX}.password-invalid-${hint.case}`
                }),
                subClass: 'show',
            };
            msgs.push(hintType);
        }
    }
    return msgs;
};

const passwordRestrictions = (intl, value) => {
    const restrictions = [
        {
            // Longer than 21 characters
            case: 'longLengthCheck',
            pattern: /^(?=.{21}).*$/g
        },
        {
            // 4 or more repeating characters
            case: 'repetitiveCheck',
            pattern: /(.)\1{3}/g
        },
        {
            case: 'consecutiveNumberCheck',
            pattern: /0123|1234|2345|3456|4567|5678|6789|7890|8901|9012/g
        },
        {
            case: 'sequenceCharacterCheck',
            pattern: /qwer|wert|erty|rtyu|tyui|yuio|uiop|asdf|sdfg|dfgh|fghj|ghjk|hjkl|zxcv|xcvb|cvbn|vbnm|QWER|WERT|ERTY|RTYU|TYUI|YUIO|UIOP|ASDF|SDFG|DFGH|FGHJ|GHJK|HJKL|ZXCV|XCVB|CVBN|VBNM/g
        },
        {
            case: 'sequenceSpecialCharactersCheck',
            pattern: /\`123|890-|90-=|iop[|op[]|p\[\]\\|jkl\;|kl\;'|bnm,|nm,.|m,.\/|~!@\#|!@\#$|@#\$%|#\$%\^|\$%\^&|\%\^&\*|\^&\*\(|&\*\(\)|\*\(\)\_|\(\)\_\+|iop\[|op\[\]|p\[\]\\|BNM<|NM<>|M\<\>\?|IOP{}|OP{}|P{}\|/g
        },
        {
            case: 'spaceCheck',
            pattern: /\s/g
        }
    ];

    const msgs = [];
    let hintType;
    for (const restriction of restrictions) {
        if (restriction.pattern.test(value)) {
            hintType = {
                msg: intl.formatMessage({
                    id: `${LOCALE_PREFIX}.password-invalid-${restriction.case}`
                }),
                subClass: 'show',
            };
            msgs.push(hintType);
        }
    }
    return msgs;
};

// Validating the password for PayPal accepted format
export const isValidPayPalPasswordFormat = intl => value => {
    const hints = passwordHints(intl, value);
    const restrictions = passwordRestrictions(intl, value);
    if (!_.isEmpty(hints) || !_.isEmpty(restrictions)) {
        return {
            msgHints: hints,
            msgRestrictions: restrictions,
            fieldType: 'password'
        };
    }
};
